export function makeNetTerms(netTerms) {
  return netTerms === 0 ? {
    type: 'immediate',
    days: null
  } : {
    type: 'net',
    days: netTerms
  };
}